import {profCourse} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadProfCourse() {
  return useLoad(profCourse, ['iD_Course', 'iD_ProfileSpac'], {});
}

export default useLoadProfCourse;
